// 性别
export let sexArr = [
  {
    label: '男',
    value: 'MALE'
  },
  {
    label: '女',
    value: 'FEMALE'
  }
]
// 年龄段数据
export let ageGroup = [
  {
    label: '0-17',
    value: '0-17'
  },
  {
    label: '18-40',
    value: '18-40'
  },
  {
    label: '41-65',
    value: '41-65'
  },
  {
    label: '>66',
    value: '>66'
  }
]
// 健康档案type枚举
export let recordTypes = [
  {
    label: '病例',
    value: 'CASE'
  },
  {
    label: '医嘱',
    value: 'MEDICAL_ADVICE'
  },
  {
    label: '体检报告',
    value: 'MEDICAL_EXAMINATION_REPORT'
  }
]
// 证件类型枚举
export let identityCardType = [
  {
    label: '中国大陆居民身份证',
    value: 'CHINESE_IDENTITY_CARD'
  },
  {
    label: '护照',
    value: 'PASSPORT'
  },
  {
    label: '军官证',
    value: 'MILITARY_ID'
  }
]
// 里程碑类型
export let milestoneTypes = [
  {
    label: '注册会员',
    value: 'MEMBER'
  },
  {
    label: '基因检测',
    value: 'GENE'
  },
  {
    label: '保险投保',
    value: 'INSURANCE'
  },
  {
    label: '子女存储脐血存储',
    value: 'CPS'
  }
]
// 钱包交易记录操作类型

export let businessTypes = [
  {
    label: '奖励发放',
    value: 'INVITATION'
  },
  {
    label: '提现',
    value: 'WITHDRAWALS'
  }
]
// 钱包交易记录操作类别枚举
export let businessTypesWallet = [
  {
    label: '邀请用户',
    value: 'INVITATION'
  },
  {
    label: '提现',
    value: 'WITHDRAWALS'
  },
  {
    label: '老带新奖励',
    value: 'CUSTOMER_BRING_NEW'
  },
  {
    label: '手动发放奖励',
    value: 'MANUAL_REWARD'
  },
  {
    label: '牙源成单奖励',
    value: 'TOOTH_ACHIEVEMENT_REWARD'
  },
  {
    label: '业务员奖励',
    value: 'SALES_REWARD'
  },
  {
    label: '邀请人奖励',
    value: 'INVITER_REWARD'
  },
  {
    label: '通用促销奖励',
    value: 'GENERIC_CASH_BACK'
  },
  {
    label: 'CPS奖励',
    value: 'CPS_BIND'
  },
  {
    label: '母亲节活动奖励',
    value: 'CUSTOMER_BRING_NEW_MOTHERS_DAY'
  },
  {
    label: '脐荐康奖励',
    value: 'CUSTOMER_BRING_NEW_QJK'
  }
]
// 用户优惠劵使用情况
export let couponStatus = [
  {
    label: '已领取',
    value: 'GOT'
  },
  {
    label: '已使用',
    value: 'USED'
  },
  {
    label: '已失效',
    value: 'INVALID'
  }
]
// 样本类型
export let sampleTypes = [
  {
    value: 'GENE',
    label: '基因检测样本'
  },
  {
    value: 'CPS',
    label: '新生儿细胞存储样本'
  },
  {
    value: 'TOOTH',
    label: '牙源'
  }
]
// 样本子类型
export let sampleSubTypes = [
  {
    label: '脐血存储',
    value: 'blood'
  },
  {
    label: '脐带存储',
    value: 'cord'
  },
  {
    label: '基因报告',
    value: 'gene'
  },
  {
    label: '胎盘亚全能',
    value: 'placenta_subomnipotence'
  },
  {
    label: '胎盘间早幼',
    value: 'placenta_young'
  },
  {
    label: '胎盘',
    value: 'placenta'
  },
  {
    label:"胎盘母体间充质存储",
    value:"placental_maternal_mesenchymal"
  }
]
// 会员升级类型
export let levelChangeTypeOptions = [
  {
    label: '升级',
    value: 'UPGRADE'
  },
  {
    label: '降级',
    value: 'DOWNGRADE'
  },
  {
    label: '保持',
    value: 'MIDGRADE'
  }
]
// 用户样本报告类型枚举
export let customerReportTypes = [
  {
    label: '脐血',
    value: 'blood'
  },
  {
    label: '脐带',
    value: 'cord'
  },
  {
    label: '胎盘亚全能',
    value: 'placenta_subomnipotence'
  },
  {
    label: '胎盘间充质',
    value: 'placenta_mesenchyme'
  },
  {
    label: '胎盘间早幼',
    value: 'placenta_young'
  },
  {
    label: '胎盘',
    value: 'placenta'
  },
  {
    label: '年检报告',
    value: 'check_year'
  },
  {
    label: '基因在线移动端报告',
    value: 'ONLINE'
  },
  {
    label: '基因PDF报告',
    value: 'DOWNLOAD'
  },
  {
    label: '基因第三方在线报告',
    value: 'EXTERNAL_ONLINE'
  },
  {
    label:"胎盘母体间充质",
    value:"placental_maternal_mesenchymal",
  }
]
